import { getMaxPricingDetailsDiscountPercent } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
export const useSaleDiscountLabel = _ref => {
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const discountPercent = getMaxPricingDetailsDiscountPercent(product == null ? void 0 : product.pricingDetails);
  const label = discountPercent !== undefined ? t('sale.product.x_off', {
    percent: discountPercent
  }) : t('premium-purchase-plan.cards.hat_sale');
  return {
    hasSale: Boolean(product == null ? void 0 : product.hasSale),
    label
  };
};
//# sourceMappingURL=useSaleDiscountLabel.js.map